import { forwardRef, useEffect, useState } from 'react';

import Image from '@/core/components/Image';
import { isWebpSupported } from '@/core/lib/image/webp';
import { useNativeContext } from '@/core/lib/native/native.context';

export interface Item {
  src: string;
  alt: string;
}

interface PhotoProps {
  index: number;
  item: Item;
  className: string;
  containerClassName?: string;
}

const Photo = forwardRef<HTMLDivElement, PhotoProps>((props, ref) => {
  const { index, item, className, containerClassName } = props;
  const { platform } = useNativeContext();
  // null while the webp support check has not resolved yet
  const [supportsWebp, setSupportsWebp] = useState<boolean | null>(null);

  useEffect(() => {
    isWebpSupported().then(setSupportsWebp);
  }, []);

  return (
    <div data-index={index} ref={ref} className={`flex snap-center snap-always ${containerClassName}`}>
      {platform === 'ios' || supportsWebp === false ? (
        <img src={item.src} alt={item.alt} className={className} />
      ) : (
        <Image loading="lazy" decoding="async" className={className} src={item.src} type="image/webp" fallback={item.src.replace('webp', 'jpg')} fallbackType="image/jpeg" alt={item.alt} />
      )}
    </div>
  );
});

export default Photo;
